import MileageSettingsDetailsResponse, {
  MileageSettingsDetailsResponseItem,
  MileageSettingsDetailsResponseMileageNumberCreationModel,
} from "../../../../api/raily/mileage/settings/details/mileage-settings-details.response";
import MileageNumberCreationModel from "../../../../types/mileage-number-creation-model";
import MileageSettingsDetails from "./mileage-settings-details";

const createCreationModel = (
  model: MileageSettingsDetailsResponseMileageNumberCreationModel,
): MileageNumberCreationModel => {
  switch (model) {
    case MileageSettingsDetailsResponseMileageNumberCreationModel.AUTO:
      return MileageNumberCreationModel.AUTO;
    case MileageSettingsDetailsResponseMileageNumberCreationModel.DICT:
      return MileageNumberCreationModel.DICT;
    case MileageSettingsDetailsResponseMileageNumberCreationModel.MANUAL:
      return MileageNumberCreationModel.MANUAL;
  }
};

const createItem = (
  item: MileageSettingsDetailsResponseItem,
): MileageSettingsDetails => {
  return {
    isCardNumberRequired: item.isCardNoRequired,
    isMileageNumberRequired: item.isMileageNoRequired,
    mileageNumberCreationModel: createCreationModel(item.mileageNoCreationType),
  };
};

const create = (
  response: MileageSettingsDetailsResponse,
): MileageSettingsDetails => {
  return createItem(response.data);
};

const mileageSettingsDetailsFactory = {
  create,
};

export default mileageSettingsDetailsFactory;
